import { SVGProps } from 'react';
import classNames from '@/common/utils/classNames';

interface LoadingProps extends SVGProps<SVGSVGElement> {
  color?: string;
  title?: string;
}

export const Loading: React.FC<LoadingProps> = props => {
  const { className, title, children, ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      role="status"
      aria-label={title || 'در حال بارگذاری'}
      {...rest}
      viewBox="0 0 200 200"
      className={classNames('patient-loading', className)}
    >
      {title && <title>{title}</title>}
      {children}
      <circle fill="currentColor" stroke="none" r="16" cx="40" cy="100" />
      <circle fill="currentColor" stroke="none" r="16" cx="100" cy="100" />
      <circle fill="currentColor" stroke="none" r="16" cx="160" cy="100" />
    </svg>
  );
};

export default Loading;
